import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import Select from 'react-select';
import DatePicker from 'react-date-picker';

import { consultaPaices, consultaEstados, consultMenciones } from '../../funciones/PefilFunction';
    
class BecaAcademicos extends Component {
    state = {
        paices: [],
        loadpaices: true,
        estados:[],
        loadEstados: false,
        caracts:[],
        menciones:[],
        loadMenciones: true,

        /* -------------------------------------- */
        institucion: this.props.datos.institucion.text,
        paisSelect: this.props.datos.paisSelect,
        estadoSelect: this.props.datos.estadoSelect,
        caracterSelect: this.props.datos.caracterSelect,
        mencionSelect: this.props.datos.mencionSelect,
        fecha: this.props.datos.fecha.text,
        ciudad: this.props.datos.ciudad.text,
        rusnies: this.props.datos.rusnies.text,
        /* -------------------------------------- */
    }

    componentDidMount = () => {
        consultaPaices ((resp) => {
            this.setState({
                paices:resp,
                loadpaices: false
            })
        })
        consultMenciones ((resp) => {
            this.setState({
                menciones:resp,
                loadMenciones: false
            })
        })
    }

    cambiaValor = (prop, err) => (e) => {
        let campo ={
            text: e.target.value,
            errMess: err
        }
        this.props.funcion(prop, campo, "datosBecaAcademicos")
    }

    valorSelectPais = (paisSelect) => {
        let campo = {value: paisSelect.value, label: paisSelect.label, errMess: "Selecciona el País de la Institución Secundaria"}
        this.props.funcion("paisSelect", campo, "datosBecaAcademicos")
        this.setState({
            paisSelect,
            loadEstados: true
        }, () => {
            consultaEstados (paisSelect.value, (resp) => {
                this.setState({
                    estados: resp,
                    loadEstados: false
                })
            })
        })
    }
    valorSelectEstado = (estadoSelect) => {
        let campo = {value: estadoSelect.value, label: estadoSelect.label, errMess: "Selecciona el Estado de la Institución Secundaria"}
        this.props.funcion("estadoSelect", campo, "datosBecaAcademicos")
        this.setState({ estadoSelect })
    }
    valorSelectCaracter = (caracterSelect) => {
        let campo = {value: caracterSelect.value, label: caracterSelect.label, errMess: ""}
        this.props.funcion("caracterSelect", campo, "datosBecaAcademicos")
        this.setState({ caracterSelect })
    }
    valorMencionCaracter = (mencionSelect) => {
        let campo = {value: mencionSelect.value, label: mencionSelect.label, errMess: "Selecciona la Mención de Educacion Secundaria"}
        this.props.funcion("mencionSelect", campo, "datosBecaAcademicos")
        this.setState({ mencionSelect })
    }

    cambiaFecha = (date) => {
        let campo = {
            text: date,
            errMess: "Selecciona la Fecha de Egreso de Educación Secundaria"
        }
        this.props.funcion("fecha", campo, "datosBecaAcademicos")
        this.setState({ fecha: date })
    }

    cambiaState = (prop) => (e) => {
        this.setState({
            [prop]: (e.target.value).toUpperCase()
        })
    }

    render() {
        let { paisSelect, paices, estadoSelect, estados, caracterSelect, mencionSelect, menciones, fecha,
            loadpaices, loadEstados, loadMenciones } = this.state;

        let { institucion, ciudad, rusnies } = this.state;

        let caracts = [
            { value: "PRI", label: 'PRIVADO' },
            { value: "PUP", label: 'PUBLICO' },
        ]

        return (
            <React.Fragment>
                <div className="custom-alert-info">Datos Académicos</div>
                <Row>
                    <Col md={12} className="custom-mt-10">
                        <div className="text-muted">Institución de Educación Secundaria *</div>
                        <input type="text" value={institucion} onChange={this.cambiaState("institucion")} onBlur={this.cambiaValor("institucion", "Selecciona la Institución de Educación Secundaria")} className="form-control" placeholder="Nombre de la Institución"/>
                    </Col>
                    <Col md={4}>
                        <div className="text-muted">País *</div>
                        <Select
                            isSearchable ={true}
                            value={paisSelect}
                            onChange={this.valorSelectPais}
                            options={paices}
                            isLoading={loadpaices}
                        />
                    </Col>
                    <Col md={4}>
                        <div className="text-muted">Estado *</div>
                        <Select
                            isSearchable ={true}
                            value={estadoSelect}
                            onChange={this.valorSelectEstado}
                            options={estados}
                            isLoading={loadEstados}
                        />
                    </Col>
                    <Col md={4}>
                        <div className="text-muted">Ciudad</div>
                        <input type="text" value={ciudad} onChange={this.cambiaState("ciudad")} onBlur={this.cambiaValor("ciudad", "")} className="form-control" placeholder="Ej.: Caracas"/>
                    </Col>
                    <Col md={3}>
                        <div className="text-muted">Carácter *</div>
                        <Select
                            isSearchable ={true}
                            value={caracterSelect}
                            onChange={this.valorSelectCaracter}
                            options={caracts}
                        />
                    </Col>
                    <Col md={3}>
                        <div className="text-muted">Bachiller Mención *</div>
                        <Select
                            isSearchable ={true}
                            value={mencionSelect}
                            onChange={this.valorMencionCaracter}
                            options={menciones}
                            isLoading={loadMenciones}
                        />
                    </Col>
                    <Col md={3}>
                        <div className="text-muted">Fecha de Egreso *</div>
                        <DatePicker
                            clearIcon= {<i className="fa fa-times"></i>}
                            calendarIcon= {<i className="fa fa-calendar"></i>}
                            className="form-control"
                            onChange={this.cambiaFecha}
                            value={fecha}
                        />
                    </Col>
                    <Col md={3}>
                        <div className="text-muted">RUSNIES *</div>
                        <input type="text" value={rusnies} onChange={this.cambiaState("rusnies")} onBlur={this.cambiaValor("rusnies", "Indica el número de la planilla RUSNIES")} className="form-control"/>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}
 
export default BecaAcademicos;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaAcademicos.jsx